import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';
import { ECoworkingOfferType } from 'shared/repositories/coworking/entities/api/V1BookCoworkingRequestSchema';

export function getCoworkingOfferTypeFieldInitialState(type: SelectedCoworkingType): ECoworkingOfferType {
  switch (type) {
    case SelectedCoworkingType.FlexibleWorkplace:
      return ECoworkingOfferType.FlexibleWorkplace;

    case SelectedCoworkingType.FixedWorkplace:
      return ECoworkingOfferType.FixedWorkplace;

    case SelectedCoworkingType.SeparateOffice:
    case SelectedCoworkingType.None:
    default:
      return ECoworkingOfferType.Office;
  }
}
